module.exports = __webpack_public_path__ + "static/CapitaLand-aa46bc601477887c2ef8a1280f3bbf25.png";